(function () {
  const SELECTOR = '[data-diggn-density-preview]';
  const DESKTOP_QUERY = '(min-width: 990px)';
  const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

  function canShowPreview(root) {
    const expectedThemeId = String(root.dataset.previewThemeId || '');
    const releaseState = String(root.dataset.releaseState || '');
    const isPublicReadyState =
      root.dataset.publicReady === 'true' && (releaseState === 'coming_soon' || releaseState === 'launched');
    const queryThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
    const currentTheme = window.Shopify?.theme;
    const isUnpublishedTheme =
      String(currentTheme?.id || '') === expectedThemeId && String(currentTheme?.role || '').toLowerCase() !== 'main';

    return Boolean(isPublicReadyState || window.Shopify?.designMode || queryThemeId === expectedThemeId || isUnpublishedTheme);
  }

  function initialise(root) {
    if (root.dataset.densityReady === 'true' || !canShowPreview(root)) return;

    root.hidden = false;
    const hero = root.querySelector('.diggn-density-preview__hero');
    const chapters = Array.from(root.querySelectorAll('[data-density-chapter]'));
    const visuals = Array.from(root.querySelectorAll('[data-density-visual]'));
    const counter = root.querySelector('[data-density-counter]');
    if (!chapters.length || chapters.length !== visuals.length) return;

    let activeIndex = -1;
    let frameRequested = false;

    function setActive(nextIndex) {
      const index = clamp(nextIndex, 0, chapters.length - 1);
      if (index === activeIndex) return;
      activeIndex = index;
      chapters.forEach((chapter, chapterIndex) => chapter.classList.toggle('is-active', chapterIndex === index));
      visuals.forEach((visual, visualIndex) => visual.classList.toggle('is-active', visualIndex === index));
      root.style.setProperty('--density-active-index', String(index));
      if (counter) counter.textContent = String(index + 1).padStart(2, '0');
    }

    function update() {
      frameRequested = false;
      const heroRect = hero?.getBoundingClientRect();
      if (heroRect) {
        const heroProgress = clamp(-heroRect.top / Math.max(heroRect.height, 1), 0, 1);
        root.style.setProperty('--density-hero-progress', heroProgress.toFixed(4));
      }

      if (!window.matchMedia(DESKTOP_QUERY).matches || window.matchMedia(REDUCED_MOTION_QUERY).matches) {
        setActive(0);
        root.style.setProperty('--density-active-progress', '0');
        return;
      }

      const focusLine = window.innerHeight * 0.52;
      let nearestIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;

      chapters.forEach((chapter, index) => {
        const rect = chapter.getBoundingClientRect();
        const distance = Math.abs(rect.top + rect.height / 2 - focusLine);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      const activeRect = chapters[nearestIndex].getBoundingClientRect();
      const activeProgress = clamp((focusLine - activeRect.top) / Math.max(activeRect.height, 1), 0, 1);
      setActive(nearestIndex);
      root.style.setProperty('--density-active-progress', activeProgress.toFixed(4));
    }

    function requestUpdate() {
      if (frameRequested) return;
      frameRequested = true;
      window.requestAnimationFrame(update);
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) requestUpdate();
      },
      { rootMargin: '40% 0px', threshold: 0 }
    );

    observer.observe(root);
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    setActive(0);
    requestUpdate();
    root.dataset.densityReady = 'true';
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(initialise);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
